import { render, staticRenderFns } from "./myCerificateCard.vue?vue&type=template&id=2279d0d6&scoped=true&"
import script from "./myCerificateCard.vue?vue&type=script&lang=js&"
export * from "./myCerificateCard.vue?vue&type=script&lang=js&"
import style0 from "./myCerificateCard.vue?vue&type=style&index=0&id=2279d0d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2279d0d6",
  null
  
)

export default component.exports